// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.shipping-label-sidebar-table {
  display: flex;
  height: 100%;
  justify-content: center;
  flex-direction: column;
  padding: 5px 5px 0 5px;
  background: #ffffff;
}
.shipping-label-sidebar-table .table {
  background: #ffffff;
  display: flex;
  justify-content: center;
  flex-direction: column;
  text-align: center;
}
.shipping-label-sidebar-table .table .table-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: x-large;
  width: 100%;
}
@media screen and (max-width: 600px) {
  .shipping-label-sidebar-table .table .table-header .search-container .form-input {
    width: 100% !important;
  }
  .shipping-label-sidebar-table .table .table-header .search-container .form-input label {
    padding: 3px;
  }
  .shipping-label-sidebar-table .table .table-header .search-container .form-input input {
    border-radius: 8px;
    width: 100% !important;
  }
  .shipping-label-sidebar-table .table .table-header .search-container {
    width: 50% !important;
  }
}
.shipping-label-sidebar-table .table .table-header .table-label {
  display: flex;
  justify-content: flex-start;
  margin: auto;
  font-weight: bold;
}
.shipping-label-sidebar-table .table .table-header .search-container {
  width: 67%;
}
.shipping-label-sidebar-table .table .btn-options {
  background: whitesmoke;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  padding: 10px;
  row-gap: 10px;
}`, "",{"version":3,"sources":["webpack://./src/components/shipping-label-sidebar-table/shipping-label-sidebar-table.styles.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,YAAA;EACA,uBAAA;EACA,sBAAA;EACA,sBAAA;EACA,mBAAA;AACF;AACE;EACE,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,kBAAA;AACJ;AACI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;AACN;AAAM;EAEI;IACE,sBAAA;EACV;EAAU;IACE,YAAA;EAEZ;EAAU;IACE,kBAAA;IACA,sBAAA;EAEZ;EAGM;IACE,qBAAA;EADR;AACF;AAIM;EACE,aAAA;EACA,2BAAA;EACA,YAAA;EACA,iBAAA;AAFR;AAKM;EACE,UAAA;AAHR;AAMI;EACE,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,mBAAA;EACA,aAAA;EACA,aAAA;AAJN","sourcesContent":[".shipping-label-sidebar-table {\n  display: flex;\n  height: 100%;\n  justify-content: center;\n  flex-direction: column;\n  padding: 5px 5px 0 5px;\n  background: #ffffff;\n\n  .table {\n    background: #ffffff;\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    text-align: center;\n\n    .table-header {\n      display: flex;\n      flex-direction: row;\n      justify-content: space-between;\n      align-items: center;\n      font-size: x-large;\n      width: 100%;\n      @media screen and (max-width: 600px) {\n        .search-container {\n          .form-input {\n            width: 100% !important;\n            label {\n              padding: 3px;\n            }\n            input {\n              border-radius: 8px;\n              width: 100% !important;\n            }\n          }\n        }\n\n        .search-container {\n          width: 50% !important;\n        }\n      }\n\n      .table-label {\n        display: flex;\n        justify-content: flex-start;\n        margin: auto;\n        font-weight: bold;\n      }\n\n      .search-container {\n        width: 67%;\n      }\n    }\n    .btn-options {\n      background: whitesmoke;\n      display: flex;\n      flex-direction: row;\n      justify-content: space-evenly;\n      align-items: center;\n      padding: 10px;\n      row-gap: 10px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
